import { get } from 'lodash'
import { MARITAL_STATUS_OPTIONS } from '../constants'
import { STATE_OPTIONS } from '../../../constants'

export const cobuyerFormFields = pathPrefix => [
  {
    label: 'Cobuyer',
    type: 'group',
    elmId: `${pathPrefix}_group`,
    fields: [
      {
        name: `${pathPrefix}.firstName`,
        label: 'Legal First Name',
        elmId: `${pathPrefix}_first_name`,
        type: 'text',
      },
      {
        name: `${pathPrefix}.middleName`,
        label: 'Legal Full Middle Name',
        elmId: `${pathPrefix}_middle_name`,
        type: 'text',
      },
      {
        name: `${pathPrefix}.noMiddleName`,
        label: 'I confirm that I do not have a middle name',
        elmId: `${pathPrefix}_no_middle_name`,
        type: 'bool',
      },
      {
        name: `${pathPrefix}.lastName`,
        label: 'Legal Last Name',
        elmId: `${pathPrefix}_last_name`,
        type: 'text',
      },
      {
        name: `${pathPrefix}.streetName`,
        label: ({ values }) => {
          const internationalCheckbox = get(
            values,
            `${pathPrefix}.internationalCheckbox`
          )
          return internationalCheckbox ? 'International Address' : 'Address'
        },
        elmId: `${pathPrefix}_street_name`,
        type: 'text',
      },
      {
        name: `${pathPrefix}.city`,
        label: 'City',
        elmId: `${pathPrefix}_city`,
        type: 'text',
        conditional: ({ values }) => {
          const internationalCheckbox = get(
            values,
            `${pathPrefix}.internationalCheckbox`
          )
          return !internationalCheckbox
        },
      },
      {
        name: `${pathPrefix}.state`,
        label: 'State',
        elmId: `${pathPrefix}_state`,
        type: 'select',
        options: STATE_OPTIONS,
        conditional: ({ values }) => {
          const internationalCheckbox = get(
            values,
            `${pathPrefix}.internationalCheckbox`
          )
          return !internationalCheckbox
        },
      },
      {
        name: `${pathPrefix}.zipCode`,
        label: 'Zip Code',
        elmId: `${pathPrefix}_zip_code`,
        type: 'text',
        conditional: ({ values }) => {
          const internationalCheckbox = get(
            values,
            `${pathPrefix}.internationalCheckbox`
          )
          return !internationalCheckbox
        },
      },
      {
        name: `${pathPrefix}.phone`,
        label: 'Phone Number',
        elmId: `${pathPrefix}_phone`,
        type: 'phone',
      },
      {
        name: `${pathPrefix}.email`,
        label: 'E-mail Address',
        elmId: `${pathPrefix}_email`,
        type: 'text',
      },
      {
        name: `${pathPrefix}.dob`,
        label: 'Date of Birth',
        elmId: `${pathPrefix}_dob`,
        type: 'date',
      },
      {
        name: `${pathPrefix}.maritalStatus`,
        label: 'Marital Status',
        elmId: `${pathPrefix}_marital_status`,
        type: 'select',
        options: MARITAL_STATUS_OPTIONS,
      },
      {
        name: `${pathPrefix}.spouseName`,
        label: 'Married To',
        elmId: `${pathPrefix}_spouse_name`,
        type: 'text',
        defaultValue: 'Someone Else',
        conditional: ({ values }) => {
          return ['MARRIED_MAN', 'MARRIED_WOMAN'].includes(
            get(values, `${pathPrefix}.maritalStatus`, '')
          )
        },
      },
    ],
  },
]

export const getMultiCobuyerFormFields = multiCobuyerData => {
  /**
   * In here we want to return a schema for summary modal based on multiCobuyerData
   * MultiCobuyerData is a datastructure shaped as an array of buyers
   * "cobuyers": [
      {
        "buyerId": 22719,
        "firstName": "Elizabeth",
        "middleName": "Teresa",
        "noMiddleName": false,
        ...
      },
      {
        "buyerId": 22720,
        "firstName": "John",
        "noMiddleName": true,
        "lastName": "Wick",
        "streetName": "12 Continental",
        "city": "New York",
        "state": "NY",
        ...
      },
   *
   * The idea is to navigate the structure and return the right piece of schema
   * depending on the buyer index
   */

  const PARENT_PATH_PREFIX = 'cobuyers'
  const multiCobuyers = get(multiCobuyerData, 'cobuyers', [])
  let multiCobuyerFormFields = []
  multiCobuyers.forEach((cobuyer, index) => {
    const cobuyerPathPrefix = `${PARENT_PATH_PREFIX}[${index}]`
    multiCobuyerFormFields = multiCobuyerFormFields.concat(
      cobuyerFormFields(cobuyerPathPrefix)
    )
  })

  return multiCobuyerFormFields
}
